import { createSelector } from 'reselect'
import {
  stringify,
  pushNewUrlParameters,
  getRouteSearchParams,
} from 'common/utils/urlUtils'

const SHOW_MODAL = 'modals/SHOW_MODAL'
const HIDE_MODAL = 'modals/HIDE_MODAL'
const HIDE_MODAL_WITH_BROWSER_HISTORY = 'modals/HIDE_MODAL_WITH_BROWSER_HISTORY'

const initialState = {
  modalType: null,
  modalProps: {},
  type: null,
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_MODAL:
      return { ...action }
    case HIDE_MODAL:
      return initialState
    case HIDE_MODAL_WITH_BROWSER_HISTORY:
      return {
        ...state,
        type: null,
      }
    default:
      return state
  }
}

export const showModal = (modalType, modalProps = {}, useBrowserHistory = false) => {
  if (useBrowserHistory) {
    addModalURL(modalType)
  }
  return ({
    type: SHOW_MODAL,
    modalType,
    modalProps,
  })
}

export const hideModal = (history = false) => {
  if (history) {
    removeModalURL()
    return { type: HIDE_MODAL_WITH_BROWSER_HISTORY }
  }
  return ({ type: HIDE_MODAL })
}

export const getModalType = createSelector(
  [getRouteSearchParams],
  (routeSearchParams) => routeSearchParams.modalType
)

export const getModalProps = (state) => state.modals.modalProps

export const addModalURL = (modalType) => {
  const newParams = {
    ...getRouteSearchParams(),
    modalType,
  }
  pushNewUrlParameters(stringify(newParams))
}

export const removeModalURL = () => {
  const newParams = {
    ...getRouteSearchParams(),
  }
  if (newParams.modalType) {
    delete newParams.modalType
  }

  pushNewUrlParameters(stringify(newParams))
}

